import Panel from '../components/panel'
import {Button} from '../components//button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { MODAL_CONFIRM_BUTTON_LABEL } from "../state/consts.ts";

export default function ModalInfoHeizkosten() {
    const pop_modal = useStore((state)=>state.pop_modal);
    
  return (<Panel >
            <p>Bei Wechsel von z. B. Öl oder Gas auf eine Wärmepumpe fallen zukünftig Kosten für den Wärmepumpenstrom an.</p>
            <Button label={"weiter"} onClick={()=>{
                pop_modal();
            }}/>
         </Panel>)
}

